var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import Model from 'models/Model';
import PrescriptionItem from './PrescriptionItem';
var Prescription = /** @class */ (function (_super) {
    __extends(Prescription, _super);
    function Prescription() {
        var _this = _super.call(this) || this;
        _this.setPrescriptionItems([]);
        return _this;
    }
    Prescription.prototype.getId = function () {
        return Number(this.id);
    };
    Prescription.prototype.getPrescriptionItems = function () {
        return plainToClass(PrescriptionItem, this.prescription_items);
    };
    Prescription.prototype.setPrescriptionItems = function (prescriptionItems) {
        this.prescription_items = prescriptionItems;
    };
    Prescription.prototype.addPrescriptionItem = function (prescriptionItems) {
        this.prescription_items.push(prescriptionItems);
    };
    Prescription.prototype.getAppointmentId = function () {
        return Number(this.appointment_id);
    };
    Prescription.prototype.setAppointmentId = function (appointmentId) {
        this.appointment_id = appointmentId;
    };
    Prescription.prototype.getPatientId = function () {
        return Number(this.patient_id);
    };
    Prescription.prototype.setPatientId = function (patientId) {
        this.patient_id = patientId;
    };
    Prescription.prototype.getCreatedAt = function () {
        if (!this.created_at)
            return '';
        return this.dateFormatter(new Date(this.created_at), 'D MMM YYYY, hh:mm A');
    };
    return Prescription;
}(Model));
export default Prescription;
